import React from "react";
import {
  CircleDollarSign,
  Presentation,
  MapPin,
  Landmark,
  Drill,
  Anchor,
  Ship,
  Fuel,
  Factory,
} from "lucide-react";
import { Link } from "react-router-dom";

const sectionBg = "/assets/images/bg2.jpeg";

const zones = [
  {
    id: 1,
    icon: CircleDollarSign,
    title: "Onne Oil & Gas Free Zone",
    body:
      "The first oil and gas export free zone to be established in the country was the Onne Oil and Gas Free Zone in Rivers State.",
    link: "/free-zones/onne",
  },
  {
    id: 2,
    icon: Presentation,
    title: "Brass Oil & Gas City",
    body:
      "These projects will facilitate the development of a world class export-oriented oil and gas processing city in Nigeria.",
    link: "/free-zones/brass",
  },
  {
    id: 3,
    icon: MapPin,
    title: "Warri Oil & Gas Free Zone",
    body:
      "In the 1980s Warri Port was built with one stop shop oil service centre covering the Western Delta area to attract companies with cost-effective benefits.",
    link: "/free-zones/warri",
  },
  {
    id: 4,
    icon: Landmark,
    title: "Eko Support Free Zone",
    body:
      "Eko Support was established in partnership with Eko Support Services Limited under a Public-Private Partnership model.",
    link: "/free-zones/eko-support",
  },
  {
    id: 5,
    icon: Drill,
    title: "Liberty Oil & Gas Free Zone",
    body:
      "In 2020, Liberty Oil and Gas Free Trade Zone was developed in partnership with Akwa Ibom State Government.",
    link: "/free-zones/liberty",
  },
  {
    id: 6,
    icon: Factory,
    title: "Notore Industrial City",
    body:
      "Notore Industrial City is predominantly a gas hub with logistics and industrial base that provides integrated solutions to companies operating in West Africa.",
    link: "/free-zones/notore-industrial-city",
  },
  {
    id: 7,
    icon: Ship,
    title: "BESTAF Maritime Industrial Oil & Gas Free Zone",
    body:
      "BESTAF Maritime Industrial Oil and Gas Free Zone is a specialized Free Zone that is export oriented to help transform Nigeria’s manufacturing capacity in the downstream sector.",
    link: "/free-zones/bestaf",
  },
  {
    id: 8,
    icon: Anchor,
    title: "Secured Bunkering Anchorage Oil & Gas Free Zone",
    body:
      "Secured Bunkering Anchorage, Lagos is the Free Zone initiated to provide Safe Bunkering Anchorage within the Gulf of Guinea and the sub-Sahara Africa sub-region.",
    link: "/free-zones/sba",
  },
  {
    id: 9,
    icon: Fuel,
    title: "Orashi Special Energy Oil and Gas Free Zone",
    body:
      "Orashi Special Energy Oil and Gas Zone, Imo State is the most recent Free Zone established in 2024 and will operate as an international gas hub for downstream investments.",
    link: "/free-zones/orashi-special-energy",
  },
];

const ProjectsSection = () => {
  return (
    <section className="relative py-24 bg-[#f4f4f4] overflow-hidden">
      <div
        className="absolute inset-0 opacity-[0.08]"
        style={{
          backgroundImage: `url(${sectionBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
        }}
      />

      <div className="absolute inset-0 bg-[#f4f4f4]/90" />

      <div className="relative max-w-7xl mx-auto px-8">
        <div className="text-center mb-20">
          <h2
            className="text-4xl md:text-5xl font-black text-[#057016] leading-tight"
            style={{ fontFamily: "'Alegreya Sans', sans-serif" }}
          >
            Oil & Gas Free Zones in Nigeria
          </h2>

          <span className="block w-10 h-[5px] bg-[#ffe21f] rounded-full mx-auto mt-5" />
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-x-20 gap-y-16">
          {zones.map((zone) => {
            const Icon = zone.icon;

            return (
              <Link
                to={zone.link}
                key={zone.id}
                className="group flex items-start gap-6"
              >
                <div className="w-[54px] h-[54px] rounded-full bg-[#003b70] text-white flex items-center justify-center flex-shrink-0 group-hover:bg-[#057016] transition-colors duration-300">
                  <Icon size={25} strokeWidth={2.2} />
                </div>

                <div>
                  <h3
                    className="text-[20px] font-black text-[#003b70] leading-tight mb-4 group-hover:text-[#057016] transition-colors"
                    style={{ fontFamily: "'Alegreya Sans', sans-serif" }}
                  >
                    {zone.title}
                  </h3>

                  <span className="block w-12 h-[5px] bg-[#ffe21f] rounded-full mb-6" />

                  <p className="text-[#6f6f6f] text-[15px] leading-[1.75]">
                    {zone.body}
                  </p>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProjectsSection;